import { PresetFrame, type PresetArtProps } from './PresetFrame';

export function Star(props: PresetArtProps) {
  return (
    <PresetFrame background="#ca8a04" {...props}>
      <path
        d="M32 13 L37.6 26.3 L52 27.5 L41 37 L44.4 51 L32 43.5 L19.6 51 L23 37 L12 27.5 L26.4 26.3 Z"
        fill="#ffffff"
        stroke="#ffffff"
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <circle cx="28" cy="33" r="2" fill="#1f2937" />
      <circle cx="36" cy="33" r="2" fill="#1f2937" />
    </PresetFrame>
  );
}
